import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function FeeSchedule() { 
  useEffect(() => {
    document.title = 'Fee Payment -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Admission</li>
                <li>Fee Payment</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Fee Payment</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <div className="table-responsive">
               <table className="table maintable">
                   <tbody>
                       <tr>
                           <td rowspan="5"><b>For All Classes</b></td>
                           <td>April & May</td>
                           <td>To Be Paid Latest By 10 May</td>
                       </tr>
                       <tr>
                           <td>June & July</td>
                           <td>To Be Paid Latest By 10 July</td>
                       </tr>
                       <tr>
                           <td>August & September</td>
                           <td>To Be Paid Latest By 10 September</td>
                       </tr>
                       <tr>
                           <td>October & November</td>
                           <td>To Be Paid Latest By 10 November</td>
                       </tr>
                       <tr>
                           <td>December & January</td>
                           <td>To Be Paid Latest By 10 January</td>
                       </tr>
                       <tr>
                           <td><b>Class IX-XII</b></td>
                           <td rowspan="2">February & March</td>
                           <td>To Be Paid Latest By 10 February (Class PG – VIII)</td>
                       </tr>
                       <tr>
                           <td><b>Class PG-VIII</b></td>
                           <td>To Be Paid Latest By 30 January (Ix – XII) Or As Notified Separately</td>
                       </tr>
                   </tbody>
               </table>
           </div>
           
          <ul className="mainlist">
                <li> Fees must be paid before/till due date in [ICICI Bank] preferably Govind Nagar / Kidwai Nagar branch. </li> 
                <li> Fees will be charged for 12 months a year, payable in advance as per the above-mentioned schedule. </li>
                <li> If the fees is not paid in full by the specified due date, a fine as notified will be charged for late payment of fees. If the fee remains unpaid as notified, the name of the student will be struck off the rolls and he / she may be re-admitted at the discretion of the Principal on payment of all arrears with a fresh Admission Fee of Rs. 1000/- (Rupees One Thousand Only). </li>
                <li> A clear calendar month notice in writing or a month’s fee in lieu of notice must be given before a pupil can be withdrawn. However, if the student is asked to leave by the school, no notice / fee is required. No claim or refund will be made for fees already paid. </li>
                <li> Transfer certificates on withdrawal are issued only after all dues to the school have been cleared. </li>
                <li> No reduction in fees will be made for continued absence whatever be the reason or for holidays taken. </li>
          </ul>
               </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default FeeSchedule;
